<template>
  <div v-if="error">
    Произошла ошибка. Обновите страницу.
  </div>
    <component :is="layout" v-if="isLoad">
      <router-view/>
    </component>
</template>

<script>
import EmptyLayout from '@/layouts/EmptyLayout'
import MainLayout from '@/layouts/MainLayout'
import axios from 'axios'
import { initializeModatechAnalytics } from './services/modatechAnalytics'
export default {
  data: () => ({
    isLoad: false,
  }),
  computed: {
    layout() {
      return (this.$route.meta.layout || 'empty') + '-layout'
    },
    error() {
      return this.$store.getters.errorRequest;
    },
    loader() {
     // return this.$store.getters.loader;
    }
  },
  components: {
    EmptyLayout, MainLayout
  },
  async created() {
    let _this = this;
    let device_uuid = this.$attrs.device_uuid;
    let device = this.$attrs.device;
    this.device_uuid = device_uuid;
    //this.$store.dispatch('Uuid', device_uuid)

    await axios.post('/api/user/', {
      device: device,
      device_uuid: device_uuid
    },{
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(function (response) {
      let data = response.data;
      data.data.device = device;
      data.data.uuid = device_uuid;
      _this.$store.dispatch('Auth', data.data)
      //console.log(data);
      _this.axios.interceptors.response.use(function (response) {
        return response;
      }, function (error) {
        if (error.response.status == 401) {
          //_this.$router.push('/auth/');
        }
        if (error.response.status == 500) {
          //_this.$router.push('/404');
        }
        return Promise.reject(error);
      });
    }).catch(function(){
      //_this.$router.push('/auth/');
    });
    initializeModatechAnalytics(axios);
    this.isLoad = true;
    if (typeof window.FirebasePlugin != 'undefined') {
      window.FirebasePlugin.onMessageReceived(function (message) {
        try {
          console.log("onMessageReceived");
          console.log(message);
          _this.$store.dispatch('readPush', message)
          if (message.url && message.tap == 'background') {
            _this.$router.push(message.url)
          }
          if (message.messageType === "notification") {
            //console.log(message);
          } else {
            //console.log(message);
          }
        } catch (e) {
          console.log("Exception in onMessageReceived callback: " + e.message);
        }

      }, function (error) {
        console.log("Failed receiving FirebasePlugin message", error);
      });
    }
  }
}
</script>